// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--T6G","error":"ChangeForm__error--2xN","captcha":"ChangeForm__captcha--1iO"};